import React from "react";

const VMS = ({ style = {}, size = "36", className = "", viewBox = "0 0 36 36" }) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <rect x={8} y={3} width={20} height={30} rx={3.5} fill="#007AFF" />
        <rect x={10.5} y={6} width={15} height={22} rx={1.6} fill="#fff" />
        <circle cx={18} cy={13} r={3.1} fill="#FFA700" />
        <path d="M13.2 24.6a4.8 4.8 0 0 1 9.6 0v1.4h-9.6v-1.4Z" fill="#FFA700" />
        <circle cx={29} cy={29} r={5.8} fill="#60B158" />
        <path
            d="M28 31.7l-2.75-2.75 1.3-1.3 1.45 1.45 3.3-3.3 1.3 1.3-4.6 4.6Z"
            fill="#fff"
        />
    </svg>
);

export default VMS;
